import { atom, selector, useRecoilState, useResetRecoilState } from 'recoil';

/**
 * 비동기 취소
 */
// atom
const asyncCancelState = atom({
  key: 'asyncCancelState',
  default: {}
});

// selector
const asyncCancelSelector = selector({
  key: 'asyncCancelSelector',
  get: ({ get }) => get(asyncCancelState),
  set: ({ set }, newValue) =>
    set(asyncCancelState, prevState => ({ ...prevState, ...newValue }))
});

// hook
function useAsyncCancelState() {
  const [asyncCancel, setAsyncCancel] = useRecoilState(asyncCancelSelector);
  const resetAsyncCancel = useResetRecoilState(asyncCancelState);

  return {
    asyncCancel,
    setAsyncCancel,
    resetAsyncCancel
  };
}

export default useAsyncCancelState;
